module.exports = __webpack_public_path__ + "static/what_you_get_art-01fb80e809ee008178303ac67e4329ab.png";